import { render, staticRenderFns } from "./PopularListOnPlate.vue?vue&type=template&id=3cf024ad&scoped=true"
import script from "./PopularListOnPlate.vue?vue&type=script&lang=js"
export * from "./PopularListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./PopularListOnPlate.vue?vue&type=style&index=0&id=3cf024ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf024ad",
  null
  
)

export default component.exports